export const NOTE = 'NOTE'
export const RATING = 'RATING'
export const TAG = 'TAG'
export const SEVERITY = 'SEVERITY'
